var map = {
	"./b-arrow.svg": 9145,
	"./card.svg": 1057,
	"./cashier.svg": 1000,
	"./close.svg": 1169,
	"./closefull.svg": 522,
	"./community.svg": 4090,
	"./course.svg": 1350,
	"./dashboard.svg": 8413,
	"./delete.svg": 7537,
	"./device.svg": 3056,
	"./edit.svg": 9692,
	"./example.svg": 457,
	"./eye-open.svg": 9290,
	"./eye.svg": 7223,
	"./feedback.svg": 9860,
	"./form.svg": 533,
	"./full.svg": 7555,
	"./hf.svg": 784,
	"./hidden_menu.svg": 6312,
	"./income.svg": 3483,
	"./language.svg": 8331,
	"./link.svg": 3803,
	"./message.svg": 9876,
	"./nested.svg": 1194,
	"./oil.svg": 8526,
	"./partner.svg": 5076,
	"./password.svg": 5055,
	"./refund.svg": 5873,
	"./report.svg": 8883,
	"./search.svg": 8236,
	"./share.svg": 3739,
	"./show_menu.svg": 781,
	"./station.svg": 7440,
	"./student.svg": 5046,
	"./system.svg": 7304,
	"./table.svg": 9581,
	"./teaching.svg": 5406,
	"./tree.svg": 892,
	"./user.svg": 9814,
	"./venue.svg": 1970,
	"./vip.svg": 5618,
	"./visit.svg": 7714,
	"./withdraw.svg": 4463,
	"./wxpay.svg": 1722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;